// extracted by mini-css-extract-plugin
module.exports = {"survey":"PublicSurveys_survey__WJk2H","disabledSurvey":"PublicSurveys_disabledSurvey__NZObt"};